import { formatPlanPrice } from '../../lib/plans.js';

/**
 * PlanCard — one column in the plan comparison grid.
 *
 * Variants:
 *  - "current" (green border, "Current plan" badge, Choose button disabled)
 *  - "popular" (black border, "Popular" badge on top)
 *  - "target" (selected for change — visual highlight, primary CTA)
 *  - default
 */
export function PlanCard({ plan, current, popular, onSelect, selecting, direction }) {
  const isCurrent = !!current;
  const classes = [
    'plan-card',
    isCurrent && 'current',
    !isCurrent && popular && 'popular',
  ].filter(Boolean).join(' ');

  const cta = isCurrent
    ? 'Current plan'
    : direction === 1
      ? `Upgrade to ${plan.name}`
      : direction === -1
        ? `Downgrade to ${plan.name}`
        : (plan.cta || `Choose ${plan.name}`);

  return (
    <div className={classes}>
      {isCurrent && <div className="plan-card-badge">Current plan</div>}
      {!isCurrent && popular && <div className="plan-card-badge">Popular</div>}

      <h3 className="plan-card-name">{plan.name}</h3>

      <div className="plan-card-price">
        {formatPlanPrice(plan)}
      </div>

      <p className="plan-card-description">{plan.description}</p>

      <ul className="plan-card-features">
        {plan.features.map((f, i) => (
          <li key={i}>{f}</li>
        ))}
      </ul>

      <button
        type="button"
        className={isCurrent ? 'btn btn-secondary' : 'btn btn-primary'}
        onClick={() => onSelect?.(plan.key)}
        disabled={isCurrent || selecting}
        style={{ width: '100%' }}
      >
        {selecting ? (
          <><span className="spinner" aria-hidden="true" /> Processing…</>
        ) : (
          cta
        )}
      </button>
    </div>
  );
}
